import React from "react";

function BS4_ProgressBars() {
  return (
    <div>
      <h1>BS4_ProgressBars Component</h1>
      <p>This is the BS4_ProgressBars tutorial page content.</p>
    </div>
  );
}

export default BS4_ProgressBars;
